import { ApolloClient, InMemoryCache } from '@apollo/client';

const apolloClient = new ApolloClient({
  uri: '/api/disability/graphql',
  cache: new InMemoryCache(),
});

export default apolloClient;
